<template>
    <div class="step-course">

        <div class="timeline-container">

            <div class="resource-btn-group">
                <el-button class="btn-course" @click="chooseCourse(1)">
                    <i class="nucfont inuc-folder-ppt"></i>添加课件
                </el-button>
                <el-button class="btn-mock" @click="chooseCourse(3)">
                    <i class="nucfont inuc-mockpaper"></i>添加模拟考试
                </el-button>
                <el-button class="btn-paper" @click="chooseCourse(2)">
                    <i class="nucfont inuc-kaoshijilu"></i>添加考试
                </el-button>
                <el-button class="btn-survey" @click="chooseSurvey">
                    <i class="nucfont inuc-feedback"></i>添加调查问卷
                </el-button>
            </div>

            <ul class="course-paper-system" id="dragsort" data-listidx="0">
                <draggable
                    v-model="courseArray"
                    draggable=".timeline-block-course"
                    :animation="200"
                    @start="drag = true"
                    @end="drag = false"
                >
                    <transition-group tag="section" type="transition" name="!drag ? 'drag' : null">
                        <li class="timeline-block-course" data-cursor="pointer" style="cursor: pointer;"
                            v-for="(item,index) in courseArray"
                            :key="''+item.id+item.resType">
                            <div class="timeline-block timeline-course"
                                 v-if="item.resType===1">
                                <div class="timeline-icon">
                                    <i class="nucfont inuc-folder-ppt"></i>
                                </div>

                                <!-- 课件 -->
                                <div class="timeline-content">
                                    <div class="operate">
                                        <a href="javascript:;" class="edit-record" :title="$t('c.edit')"
                                           @click="dialogShow(item)">
                                            <i class="nucfont inuc-edit"></i>
                                        </a>

                                        <el-popconfirm
                                            :title="$t('m.delete')"
                                            @confirm="deleteCourse(item.courseID)"
                                        >
                                            <a href="javascript:;" class="delete-record"
                                               :title="$t('c.delete')"
                                               slot="reference">
                                                <i class="nucfont inuc-delete"></i>
                                            </a>
                                        </el-popconfirm>
                                    </div>
                                    <div class="content">
                                        <h3 class="content-title">
                                            课件：{{ item.name || item.courseName }}
                                        </h3>
                                        <el-row class="content-txt">
                                            <el-col :span="8">
                                                <label>{{ $t('course.type') }}</label>：
                                                <span>{{ item.typeName || item.courseTypeName }}</span>
                                            </el-col>
                                            <el-col :span="8">
                                                <label>{{ $t('c.knowledgePoint') }}</label>：
                                                <span>{{ item.knowledgeName || item.courseKnowledgeName }}</span>
                                            </el-col>
                                        </el-row>
                                        <el-row class="content-txt">
                                            <el-col :span="8" v-if="item.extra && item.extra.hours">
                                                <label>{{ $t('train.hour') }}</label>：
                                                <span>{{ item.extra.hours }}</span>
                                            </el-col>
                                            <el-col :span="8" v-if="item.extra && item.extra.credit">
                                                <label>{{ $t('train.credit') }}</label>：
                                                <span>{{ item.extra.credit }}</span>
                                            </el-col>
                                            <el-col :span="8" v-if="item.extra && item.extra.intervalTime">
                                                <label>弹窗设置</label>：
                                                <span>{{ item.extra.intervalTime }}秒</span>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </div>
                            </div>

                            <!-- 考卷 -->
                            <div class="timeline-block"
                                 v-if="item.resType===2 || item.resType===3"
                                 :class="item.resType===2?'timeline-paper': 'timeline-mockPaper'">
                                <div class="timeline-icon">
                                    <i v-if="item.resType===2" class="nucfont inuc-kaoshijilu"></i>
                                    <i v-else class="nucfont inuc-mockpaper"></i>
                                </div>
                                <div class="timeline-content">

                                    <div class="operate">
                                        <a href="javascript:;" class="edit-record" :title="$t('c.edit')"
                                           @click="dialogShow(item)">
                                            <i class="nucfont inuc-edit"></i>
                                        </a>

                                        <el-popconfirm
                                            :title="$t('m.delete')"
                                            @confirm="deleteCourse((item.paperID || item.mockPaperID) +'_'+item.resType, true)"
                                        >
                                            <a href="javascript:;" class="delete-record"
                                               :title="$t('c.delete')"
                                               slot="reference">
                                                <i class="nucfont inuc-delete"></i>
                                            </a>
                                        </el-popconfirm>
                                    </div>

                                    <div class="content">
                                        <h3 class="content-title">
                                            {{ item.resType === 2 ? '考试' : '模拟考试' }}：{{ item.title || item.paperName || item.mockPaperName }}
                                        </h3>
                                        <el-row class="content-txt">
                                            <!-- 考卷/模考共有 -->
                                            <el-col :span="8">
                                                <label>{{ $t('paper.type') }}</label>：
                                                <span>{{ item.typeName || item.paperTypeName || item.mockPaperTypeName }}</span>
                                            </el-col>
                                            <el-col :span="8">
                                                <label>{{ $t('c.knowledgePoint') }}</label>：
                                                <span>{{ item.knowledgeName || item.paperKnowledgeName || item.mockPaperKnowledgeName }}</span>
                                            </el-col>
                                            <el-col :span="8" v-if="item.extra">
                                                <label>{{ $t('paper.testPeriod') }}</label>：
                                                <span v-if="item.extra.duration">{{ item.extra.duration }}</span>
                                                <span v-else class="warn">{{ $t('c.unset') }}</span>
                                            </el-col>
                                            <el-col :span="8" v-if="item.extra && item.extra.hours">
                                                <label>{{ $t('train.hour') }}</label>：
                                                <span>{{ item.extra.hours }}</span>
                                            </el-col>
                                            <el-col :span="8" v-if="item.extra && item.extra.credit">
                                                <label>{{ $t('train.credit') }}</label>：
                                                <span>{{ item.extra.credit }}</span>
                                            </el-col>
                                            <!-- 职鉴：考试模式 -->
                                            <el-col :span="8" v-if="item.type === 5 || item.paperType === 5 || item.mockPaperType === 5">
                                                <label>考试模式</label>：<span>{{ item.extra.isSimulationMode ? '走图': '单题' }}</span>
                                            </el-col>

                                            <!-- 考卷 -->
                                            <template v-if="item.extra && item.resType===2">
                                                <el-col :span="8">
                                                    <label>{{ $t('paper.disorder') }}</label>：<span>{{
                                                        item.extra.disorder === false ? $t('c.no') : $t('c.yes')
                                                    }}</span>
                                                </el-col>
                                                <el-col :span="8">
                                                    <label>{{ $t('paper.allowReview') }}</label>：<span>{{ item.extra.allowReview === false ? $t('c.no') : $t('c.yes') }}</span>
                                                </el-col>
                                                <el-col :span="8" v-if="item.extra.allowReview">
                                                    <label>{{ $t('paper.publishTime') }}</label>：<span>{{ item.extra.deadline ? item.extra.deadline.replace("T", " ") : $t('paper.showAnswerAfterExam') }}</span>
                                                </el-col>
                                                <el-col :span="8" v-if="item.extra.allowResit">
                                                    <label>{{ $t('paper.allowResitTimes') }}</label>：<span>{{ item.extra.resit }}</span>
                                                </el-col>
                                                <el-col :span="8" v-if="item.extra.isAntiCheating">
                                                    <label>{{ $t('paper.faceMatching') }}</label>：<span>{{ $t('c.enabled') }}</span>
                                                </el-col>
                                                <el-col :span="8" v-if="item.extra.isMonitor">
                                                    <label>{{ $t('paper.photoDuration') }}</label>：<span>{{item.extra.photoDuration}}{{ $t('paper.secondPerTime') }}</span>
                                                </el-col>
                                            </template>

                                            <!-- 模考 -->
                                            <template v-if="item.extra && item.resType===3">
                                                <el-col :span="8" v-if="item.extra.passLine">
                                                    <label>{{ $t('topic.mockPassLine') }}</label>：<span>{{ item.extra.passLine }}</span>
                                                </el-col>
                                            </template>
                                        </el-row>
                                    </div>
                                </div>
                            </div>

                            <!-- 调查问卷 -->
                            <div class="timeline-block timeline-survey"
                                 v-if="item.resType===4">
                                <div class="timeline-icon">
                                    <i class="nucfont inuc-feedback"></i>
                                </div>
                                <div class="timeline-content">
                                    <div class="operate">
                                        <el-popconfirm
                                            :title="$t('m.delete')"
                                            @confirm="deleteCourse(item.businessId)"
                                        >
                                            <a href="javascript:;" class="delete-record"
                                               :title="$t('c.delete')"
                                               slot="reference">
                                                <i class="nucfont inuc-delete"></i>
                                            </a>
                                        </el-popconfirm>
                                    </div>

                                    <div class="content">
                                        <h3 class="content-title">
                                            调查问卷：{{ item.name || item.businessName }}
                                        </h3>
                                    </div>
                                </div>
                            </div>

                        </li>
                    </transition-group>
                </draggable>
            </ul>
        </div>

        <div class="no-course-paper" v-if="!courseArray.length">
            <p><i class="nucfont inuc-edit1"></i>{{ $t('train.chooseTip') }}</p>
        </div>

        <!-- 资源选择弹框 -->
        <course-selector
            :type="dialog.type"
            :dialogOpen="dialog.courseDialog"
            :initData="dialog.initData"
            @onDialogClosed="dialog.courseDialog=false"
            @onSelectOver="chooseCourseOver">
        </course-selector>

        <!-- 问卷选择弹框 -->
        <survey-selector
            v-model="surveyDialog.visible"
            :initIds="surveyDialog.initIds"
            @onSelectOver="chooseCourseOver">

        </survey-selector>

        <!-- 资源编辑弹框 -->
        <course-editor
            :courseEditor.sync="courseEditor"
            :courseEditorItem="courseEditorItem"
            @dialog-save="dialogSave">
        </course-editor>
    </div>
</template>

<script>
import CourseSelector from './CourseSelector';
import CourseEditor from "./CourseEditor"
import SurveySelector from "./SurveySelector";
import draggable from 'vuedraggable'

export default {
    components: {
        CourseSelector,
        CourseEditor,
        SurveySelector,
        draggable,
    },

    data() {
        return {
            // 第三步
            courseArray: [],
            courseEditor: false,
            courseEditorItem: {},

            dialog: {
                type: 1,
                courseDialog: false,
                paperDialog: false,
                initData: {}
            },
            surveyDialog: {
                visible: false,
                initIds: []
            },
            submitLoading: false,
            drag: false,
        }
    },

    methods: {
        fillData(data) {
            /**
             * "resType"是手动加的属性，用于类型判断：1课件 2考卷 3模拟考卷 4调查问卷
             * 在courseDialog里，也是手动加的这个属性
             */
            this.courseArray = data.processes;
            this.courseArray.forEach((val, index) => {
                if (val.courseID) {
                    this.courseArray[index].resType = 1;
                    this.courseArray[index].extra = {
                        hours: val.hours || 0,
                        credit: val.credit || 0,
                        intervalTime: val.intervalTime || 0,
                        expandSet: val.expandSet || []
                    }

                } else if (val.paperID) {
                    this.courseArray[index].resType = 2;
                    let expandSet = []

                    if (val.expandSet && val.expandSet.length) {
                        expandSet = val.expandSet.map(item => {
                            item.percentage = (item.percentage * 100).toFixed(2) - 0
                            return item
                        })
                    }

                    if (!val.duration) return

                    this.courseArray[index].extra = {
                        //name: val.paperName,
                        duration: val.duration + '',
                        hours: val.hours || 0,
                        credit: val.credit || 0,
                        deadline: val.deadline,
                        allowReview: val.allowReview,
                        allowResit: val.resit > 0,
                        resit: val.resit,
                        disorder: val.disorder,
                        isSimulationMode: val.isSimulationMode,
                        isAntiCheating: val.isAntiCheating,
                        isMonitor: val.isMonitor,
                        photoDuration: val.photoDuration,
                        expandSet
                    }
                } else if (val.mockPaperID) {
                    this.courseArray[index].resType = 3;

                    if (!val.duration) return
                    this.courseArray[index].extra = {
                        //name: val.mockPaperName,
                        duration: val.duration + '',
                        hours: val.hours || 0,
                        credit: val.credit || 0,
                        passLine: val.passLine,
                        isSimulationMode: val.isSimulationMode,
                    }
                } else if (val.businessType === 4) {
                    this.courseArray[index].resType = 4;
                }
            });
        },

        getData() {
            let processes = []

            this.courseArray.forEach((item, index) => {
                if (item.resType === 1) {
                    processes.push({
                        courseID: item.courseID,
                        order: index + 1,
                        hours: item.extra.hours,
                        credit: item.extra.credit,
                        intervalTime: item.extra.intervalTime || 0,
                        expandSet: item.extra.expandSet
                    })
                } else if (item.resType === 2) {
                    let obj = {
                        paperID: item.paperID,
                        order: index + 1,
                        duration: item.extra.duration,
                        hours: item.extra.hours,
                        credit: item.extra.credit,
                        deadline: item.extra.deadline,
                        allowReview: item.extra.allowReview,
                        disorder: item.extra.disorder,
                        isSimulationMode: item.extra.isSimulationMode,
                        isAntiCheating: item.extra.isAntiCheating,
                        isMonitor: item.extra.isMonitor,
                        photoDuration: item.extra.photoDuration,
                        resit: item.extra.allowResit ? item.extra.resit : 0,
                    }
                    if (item.extra.expandSet && item.extra.expandSet.length) {
                        obj.expandSet = item.extra.expandSet.map(v => {
                            return {
                                ...v,
                                percentage: (v.percentage * 0.01).toFixed(2) - 0
                            }
                        })
                    }

                    processes.push(obj)
                } else if (item.resType === 3) {
                    processes.push({
                        mockPaperID: item.mockPaperID,
                        order: index + 1,
                        duration: item.extra.duration,
                        hours: item.extra.hours,
                        credit: item.extra.credit,
                        passLine: item.extra.passLine || null,
                        isSimulationMode: item.extra.isSimulationMode,
                    })
                } else if (item.resType === 4) {
                    processes.push({
                        businessId: item.businessId,
                        businessName: item.name || item.businessName,
                        businessType: 4,
                        order: index + 1,
                    })
                }
            })

            return processes
        },

        /**
         * 编辑试卷相关
         */
        dialogShow(item) {
            this.courseEditor = true
            this.courseEditorItem = item
        },
        dialogSave(data) {
            if (data.type === 1) {
                let index = this.courseArray.findIndex(val => val.courseID == data.id);

                let newItem = {
                    ...this.courseArray[index],
                    extra: {
                        hours: data.hours,
                        credit: data.credit,
                        intervalTime: data.intervalTime,
                        expandSet: data.expandSet
                    }
                }

                this.$set(this.courseArray, index, newItem)

            } else if (data.type === 2) {
                let index = this.courseArray.findIndex(val => val.paperID == data.id);

                let newItem = {
                    ...this.courseArray[index],
                    extra: {
                        duration: data.duration + '',
                        hours: data.hours,
                        credit: data.credit,
                        disorder: data.disorder,
                        isSimulationMode: data.isSimulationMode,
                        isAntiCheating: data.isAntiCheating,
                        isMonitor: data.isMonitor,
                        photoDuration: data.photoDuration,
                        allowReview: data.allowReview,
                        allowResit: data.allowResit,
                        resit: data.resit,
                        deadline: data.allowReview ? data.deadline: null,
                        expandSet: data.expandSet
                    }
                }

                this.$set(this.courseArray, index, newItem)

            } else if (data.type === 3) {
                let index = this.courseArray.findIndex(val => val.mockPaperID == data.id);

                let newItem = {
                    ...this.courseArray[index],
                    extra: {
                        duration: data.duration + '',
                        hours: data.hours,
                        credit: data.credit,
                        passLine: data.passLine,
                        isSimulationMode: data.isSimulationMode,
                    }
                }

                this.$set(this.courseArray, index, newItem)
            }
        },

        // 打开对话框
        chooseCourse(type) {
            this.dialog.type = type;
            this.dialog.courseDialog = true;

            let idArray = [];

            this.courseArray.forEach(ele => {
                //idArray.push(ele.courseID || ele.paperID || ele.mockPaperID);
                idArray.push({
                    type: ele.resType,
                    id: ele.courseID || ele.paperID || ele.mockPaperID
                })
            });

            this.dialog.initData = {
                ids: idArray,
            };
        },
        chooseSurvey() {
            this.surveyDialog.visible = true

            let surveyArr = this.courseArray.filter(item => item.resType === 4)
            this.surveyDialog.initIds = surveyArr.map(item => item.businessId)

        },
        // 对话框课件选择完毕的回调
        chooseCourseOver(data) {
            console.log(data);

            data.forEach(ele => {

                if (ele.resType === 1) {
                    if (!this.courseArray.find(arr => arr.courseID === ele.courseID)) {
                        let obj = {
                            ...ele,
                            extra: {
                                hours: ele.hours,
                                credit: ele.credit
                            }
                        }
                        this.courseArray.push(obj);
                    }
                }

                if (ele.resType === 2) {
                    if (!this.courseArray.find(arr => arr.paperID === ele.paperID)) {
                        this.courseArray.push({
                            ...ele,
                            extra: {}
                        });
                    }
                }

                if (ele.resType === 3) {
                    if (!this.courseArray.find(arr => arr.mockPaperID === ele.mockPaperID)) {
                        this.courseArray.push({
                            ...ele,
                            extra: {}
                        });
                    }
                }

                if (ele.resType === 4) {
                    if (!this.courseArray.find(arr => arr.businessId === ele.businessId)) {
                        this.courseArray.push(ele);
                    }
                }
            });
        },

        deleteCourse(id, isPaper) {
            let index = 0;
            if (!isPaper) {
                index = this.courseArray.findIndex(ele => {
                    return ele.courseID == id || ele.businessId == id
                });
            } else {
                let pID = id.split('_')[0];
                let type = id.split('_')[1];

                if (type == 2) {
                    index = this.courseArray.findIndex(ele => {
                        return ele.paperID == pID;
                    });
                } else if (type == 3) {
                    index = this.courseArray.findIndex(ele => {
                        return ele.mockPaperID == pID;
                    });
                }
            }

            if (index > -1) {
                this.courseArray.splice(index, 1);
            }
        },

        clear() {
            this.courseArray = []
        },
    },
}
</script>

<style scoped lang="scss">

.step-course {
    padding-bottom: 30px;
}

.resource-btn-group {
    margin-bottom: 22px;

    button {
        @include button-size(9px, 15px, 14px, 3px);

        .nucfont {
            margin-right: 4px;
            color: #fff;
        }

        + button {
            margin-left: 12px;
        }
    }

    .btn-course {
        @include button-variant(#fff, $c-course, $c-course);
    }

    .btn-mock {
        @include button-variant(#fff, $c-mock, $c-mock);
    }

    .btn-paper {
        @include button-variant(#fff, $c-paper, $c-paper);
    }

    .btn-survey {
        @include button-variant(#fff, $c-survey, $c-survey);
    }
}

/*****时间轴****/
.timeline-container {
    position: relative;
    width: 80%;
    max-width: 1080px;
    margin: 15px auto;

    .course-paper-system {
        position: relative;

        &:before {
            content: '';
            position: absolute;
            top: 0;
            bottom: 0px;
            left: 26px;
            border-left: 1px dashed #ccc;
        }
    }

    .timeline-block {
        position: relative;

        &:after {
            content: '';
            position: absolute;
            bottom: -5px;
            left: 20px;
            width: 12px;
            height: 12px;
            background-color: #fff;
            border: 1px solid #ccc;
            border-radius: 50%;
        }

        .timeline-icon {
            position: absolute;
            top: 50%;
            left: 0;
            width: 56px;
            height: 56px;
            transform: translateY(-50%);
            text-align: center;
            color: #fff;
            border: 5px solid;
            border-radius: 50%;
            cursor: default;

            > .nucfont {
                font-size: 24px;
                vertical-align: -20px;
            }
        }

        .operate {
            position: absolute;
            right: 5px;
            top: 15px;

            .nucfont {
                margin-right: 10px;
                color: #a3a4a9;
                font-size: 18px;

                &:hover {
                    color: #9267d7;
                }

                &.inuc-delete:hover {
                    color: #ec7063;
                }
            }
        }
    }

    .timeline-content {
        position: relative;
        margin-left: 80px;
        background: #fff;
        color: #676a6c;
        border: solid 1px $c-border;
        border-bottom: none;

        &:hover {
            background-color: #faf9fc;
            cursor: move;

            &:after {
                content: '';
                position: absolute;
                top: 42%;
                right: 100%;
                height: 0;
                width: 0;
                border: 14px solid transparent;
                border-right: 14px solid #faf9fc;
            }

            &:before {
                content: '';
                position: absolute;
                top: 42%;
                right: 100%;
                height: 0;
                width: 0;
                margin-right: 1px;
                border: 14px solid transparent;
                border-right: 14px solid $c-border;
            }
        }
    }

    ul li:last-child {
        .timeline-content {
            border-bottom: 1px solid $c-border;
        }
    }
}

.timeline-content {
    .content {
        padding: 12px 20px;
        min-height: 120px;
    }

    .content-title {
        display: inline-block;
        padding: 0 10px;
        margin-bottom: 10px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        border: solid 1px #e6e6e6;
        border-radius: 4px;
        background-color: #f4f3f8;
    }

    .content-txt {
        //margin-top: 10px;
        margin-bottom: 4px;

        span {
            font-weight: 600;
        }

        .warn {
            padding: 3px 6px;
            background-color: $c-danger;
            color: #fff;
            font-size: 12px;
        }

        > .el-col {
            line-height: 1.8;
        }
    }

}

.timeline-course {
    .timeline-icon {
        background-color: $c-course;
        border-color: #e0f4ff !important;
    }

    .content-title {
        color: $c-course;
        border-color: mix($c-course, #fff, 20%);
        background-color: mix($c-course, #fff, 10%);
    }
}

.timeline-mockPaper {
    .timeline-icon {
        background-color: $c-mock;
        border-color: #c9fdf3 !important;
    }

    .content-title {
        color: $c-mock;
        border-color: mix($c-mock, #fff, 20%);
        background-color: mix($c-mock, #fff, 10%);
    }
}

.timeline-paper {
    .timeline-icon {
        background-color: $c-paper;
        border-color: #fff3e6 !important;
    }

    .content-title {
        color: shade($c-paper, 90%);
        border-color: mix($c-paper, #fff, 20%);
        background-color: mix($c-paper, #fff, 10%);
    }
}

.timeline-survey {
    .timeline-icon {
        background-color: $c-survey;
        border-color: tint($c-survey, 20%) !important;
    }

    .content-title {
        color: $c-survey;
        border-color: mix($c-survey, #fff, 20%);
        background-color: mix($c-survey, #fff, 10%);
    }

    .content {
        min-height: 80px;
    }
}

.no-course-paper {
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #999;
    letter-spacing: 1px;

    .nucfont {
        margin-right: 4px;
    }
}


.drag-move {
    transition: all .3s;
}

</style>
